const ct = "active", ut = "autocomplete", ft = "batch", dt = "chart", ht = "checkbox", lt = "chips", mt = "color", $t = "country", pt = "currency", Mt = "datatable", Dt = "datetime", yt = "date", gt = "email", Yt = "file", Tt = "filter", Et = "hidden", _t = "image", St = "multiple", wt = "number", Ot = "password", vt = "radio", Lt = "reader", At = "select", xt = "skeleton", Pt = "terms and conditions", bt = "textarea", Ct = "text", Ht = "time", Nt = "sidebar screen", Ae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVE_TYPE: ct,
  AUTOCOMPLETE_TYPE: ut,
  BATCH_TYPE: ft,
  CHART_TYPE: dt,
  CHECKBOX_TYPE: ht,
  CHIPS_TYPE: lt,
  COLOR_TYPE: mt,
  COUNTRY_TYPE: $t,
  CURRENCY_TYPE: pt,
  DATA_TABLE_TYPE: Mt,
  DATE_TIME_TYPE: Dt,
  DATE_TYPE: yt,
  EMAIL_TYPE: gt,
  FILE_TYPE: Yt,
  FILTER_TYPE: Tt,
  HIDDEN_TYPE: Et,
  IMAGE_TYPE: _t,
  MULTIPLE_TYPE: St,
  NUMBER_TYPE: wt,
  PASSWORD_TYPE: Ot,
  RADIO_TYPE: vt,
  READER_TYPE: Lt,
  SELECT_TYPE: At,
  SIDEBAR_SCREEN_LAYOUT: Nt,
  SKELETON_TYPE: xt,
  TERMS_AND_CONDITIONS_TYPE: Pt,
  TEXT_AREA_TYPE: bt,
  TEXT_TYPE: Ct,
  TIME_TYPE: Ht
}, Symbol.toStringTag, { value: "Module" })), xe = (t = "") => t.toLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "");
function jt() {
  const t = Math.floor(Math.random() * 16777215).toString(16);
  return t.length === 6 ? `#${t}` : jt();
}
var et = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var nt = { exports: {} };
(function(t, e) {
  (function(u, h) {
    t.exports = h();
  })(et, function() {
    var u = 1e3, h = 6e4, $ = 36e5, T = "millisecond", Y = "second", _ = "minute", Z = "hour", M = "day", X = "week", v = "month", G = "quarter", U = "year", B = "date", f = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, D = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(o) {
      var s = ["th", "st", "nd", "rd"], r = o % 100;
      return "[" + o + (s[(r - 20) % 10] || s[r] || s[0]) + "]";
    } }, x = function(o, s, r) {
      var i = String(o);
      return !i || i.length >= s ? o : "" + Array(s + 1 - i.length).join(r) + o;
    }, N = { s: x, z: function(o) {
      var s = -o.utcOffset(), r = Math.abs(s), i = Math.floor(r / 60), n = r % 60;
      return (s <= 0 ? "+" : "-") + x(i, 2, "0") + ":" + x(n, 2, "0");
    }, m: function o(s, r) {
      if (s.date() < r.date())
        return -o(r, s);
      var i = 12 * (r.year() - s.year()) + (r.month() - s.month()), n = s.clone().add(i, v), a = r - n < 0, c = s.clone().add(i + (a ? -1 : 1), v);
      return +(-(i + (r - n) / (a ? n - c : c - n)) || 0);
    }, a: function(o) {
      return o < 0 ? Math.ceil(o) || 0 : Math.floor(o);
    }, p: function(o) {
      return { M: v, y: U, w: X, d: M, D: B, h: Z, m: _, s: Y, ms: T, Q: G }[o] || String(o || "").toLowerCase().replace(/s$/, "");
    }, u: function(o) {
      return o === void 0;
    } }, j = "en", L = {};
    L[j] = y;
    var C = "$isDayjsObject", P = function(o) {
      return o instanceof O || !(!o || !o[C]);
    }, H = function o(s, r, i) {
      var n;
      if (!s)
        return j;
      if (typeof s == "string") {
        var a = s.toLowerCase();
        L[a] && (n = a), r && (L[a] = r, n = a);
        var c = s.split("-");
        if (!n && c.length > 1)
          return o(c[0]);
      } else {
        var l = s.name;
        L[l] = s, n = l;
      }
      return !i && n && (j = n), n || !i && j;
    }, p = function(o, s) {
      if (P(o))
        return o.clone();
      var r = typeof s == "object" ? s : {};
      return r.date = o, r.args = arguments, new O(r);
    }, d = N;
    d.l = H, d.i = P, d.w = function(o, s) {
      return p(o, { locale: s.$L, utc: s.$u, x: s.$x, $offset: s.$offset });
    };
    var O = function() {
      function o(r) {
        this.$L = H(r.locale, null, !0), this.parse(r), this.$x = this.$x || r.x || {}, this[C] = !0;
      }
      var s = o.prototype;
      return s.parse = function(r) {
        this.$d = function(i) {
          var n = i.date, a = i.utc;
          if (n === null)
            return /* @__PURE__ */ new Date(NaN);
          if (d.u(n))
            return /* @__PURE__ */ new Date();
          if (n instanceof Date)
            return new Date(n);
          if (typeof n == "string" && !/Z$/i.test(n)) {
            var c = n.match(m);
            if (c) {
              var l = c[2] - 1 || 0, g = (c[7] || "0").substring(0, 3);
              return a ? new Date(Date.UTC(c[1], l, c[3] || 1, c[4] || 0, c[5] || 0, c[6] || 0, g)) : new Date(c[1], l, c[3] || 1, c[4] || 0, c[5] || 0, c[6] || 0, g);
            }
          }
          return new Date(n);
        }(r), this.init();
      }, s.init = function() {
        var r = this.$d;
        this.$y = r.getFullYear(), this.$M = r.getMonth(), this.$D = r.getDate(), this.$W = r.getDay(), this.$H = r.getHours(), this.$m = r.getMinutes(), this.$s = r.getSeconds(), this.$ms = r.getMilliseconds();
      }, s.$utils = function() {
        return d;
      }, s.isValid = function() {
        return this.$d.toString() !== f;
      }, s.isSame = function(r, i) {
        var n = p(r);
        return this.startOf(i) <= n && n <= this.endOf(i);
      }, s.isAfter = function(r, i) {
        return p(r) < this.startOf(i);
      }, s.isBefore = function(r, i) {
        return this.endOf(i) < p(r);
      }, s.$g = function(r, i, n) {
        return d.u(r) ? this[i] : this.set(n, r);
      }, s.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, s.valueOf = function() {
        return this.$d.getTime();
      }, s.startOf = function(r, i) {
        var n = this, a = !!d.u(i) || i, c = d.p(r), l = function(k, w) {
          var b = d.w(n.$u ? Date.UTC(n.$y, w, k) : new Date(n.$y, w, k), n);
          return a ? b : b.endOf(M);
        }, g = function(k, w) {
          return d.w(n.toDate()[k].apply(n.toDate("s"), (a ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(w)), n);
        }, E = this.$W, S = this.$M, A = this.$D, V = "set" + (this.$u ? "UTC" : "");
        switch (c) {
          case U:
            return a ? l(1, 0) : l(31, 11);
          case v:
            return a ? l(1, S) : l(0, S + 1);
          case X:
            var F = this.$locale().weekStart || 0, z = (E < F ? E + 7 : E) - F;
            return l(a ? A - z : A + (6 - z), S);
          case M:
          case B:
            return g(V + "Hours", 0);
          case Z:
            return g(V + "Minutes", 1);
          case _:
            return g(V + "Seconds", 2);
          case Y:
            return g(V + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, s.endOf = function(r) {
        return this.startOf(r, !1);
      }, s.$set = function(r, i) {
        var n, a = d.p(r), c = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[M] = c + "Date", n[B] = c + "Date", n[v] = c + "Month", n[U] = c + "FullYear", n[Z] = c + "Hours", n[_] = c + "Minutes", n[Y] = c + "Seconds", n[T] = c + "Milliseconds", n)[a], g = a === M ? this.$D + (i - this.$W) : i;
        if (a === v || a === U) {
          var E = this.clone().set(B, 1);
          E.$d[l](g), E.init(), this.$d = E.set(B, Math.min(this.$D, E.daysInMonth())).$d;
        } else
          l && this.$d[l](g);
        return this.init(), this;
      }, s.set = function(r, i) {
        return this.clone().$set(r, i);
      }, s.get = function(r) {
        return this[d.p(r)]();
      }, s.add = function(r, i) {
        var n, a = this;
        r = Number(r);
        var c = d.p(i), l = function(S) {
          var A = p(a);
          return d.w(A.date(A.date() + Math.round(S * r)), a);
        };
        if (c === v)
          return this.set(v, this.$M + r);
        if (c === U)
          return this.set(U, this.$y + r);
        if (c === M)
          return l(1);
        if (c === X)
          return l(7);
        var g = (n = {}, n[_] = h, n[Z] = $, n[Y] = u, n)[c] || 1, E = this.$d.getTime() + r * g;
        return d.w(E, this);
      }, s.subtract = function(r, i) {
        return this.add(-1 * r, i);
      }, s.format = function(r) {
        var i = this, n = this.$locale();
        if (!this.isValid())
          return n.invalidDate || f;
        var a = r || "YYYY-MM-DDTHH:mm:ssZ", c = d.z(this), l = this.$H, g = this.$m, E = this.$M, S = n.weekdays, A = n.months, V = n.meridiem, F = function(w, b, W, J) {
          return w && (w[b] || w(i, a)) || W[b].slice(0, J);
        }, z = function(w) {
          return d.s(l % 12 || 12, w, "0");
        }, k = V || function(w, b, W) {
          var J = w < 12 ? "AM" : "PM";
          return W ? J.toLowerCase() : J;
        };
        return a.replace(D, function(w, b) {
          return b || function(W) {
            switch (W) {
              case "YY":
                return String(i.$y).slice(-2);
              case "YYYY":
                return d.s(i.$y, 4, "0");
              case "M":
                return E + 1;
              case "MM":
                return d.s(E + 1, 2, "0");
              case "MMM":
                return F(n.monthsShort, E, A, 3);
              case "MMMM":
                return F(A, E);
              case "D":
                return i.$D;
              case "DD":
                return d.s(i.$D, 2, "0");
              case "d":
                return String(i.$W);
              case "dd":
                return F(n.weekdaysMin, i.$W, S, 2);
              case "ddd":
                return F(n.weekdaysShort, i.$W, S, 3);
              case "dddd":
                return S[i.$W];
              case "H":
                return String(l);
              case "HH":
                return d.s(l, 2, "0");
              case "h":
                return z(1);
              case "hh":
                return z(2);
              case "a":
                return k(l, g, !0);
              case "A":
                return k(l, g, !1);
              case "m":
                return String(g);
              case "mm":
                return d.s(g, 2, "0");
              case "s":
                return String(i.$s);
              case "ss":
                return d.s(i.$s, 2, "0");
              case "SSS":
                return d.s(i.$ms, 3, "0");
              case "Z":
                return c;
            }
            return null;
          }(w) || c.replace(":", "");
        });
      }, s.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, s.diff = function(r, i, n) {
        var a, c = this, l = d.p(i), g = p(r), E = (g.utcOffset() - this.utcOffset()) * h, S = this - g, A = function() {
          return d.m(c, g);
        };
        switch (l) {
          case U:
            a = A() / 12;
            break;
          case v:
            a = A();
            break;
          case G:
            a = A() / 3;
            break;
          case X:
            a = (S - E) / 6048e5;
            break;
          case M:
            a = (S - E) / 864e5;
            break;
          case Z:
            a = S / $;
            break;
          case _:
            a = S / h;
            break;
          case Y:
            a = S / u;
            break;
          default:
            a = S;
        }
        return n ? a : d.a(a);
      }, s.daysInMonth = function() {
        return this.endOf(v).$D;
      }, s.$locale = function() {
        return L[this.$L];
      }, s.locale = function(r, i) {
        if (!r)
          return this.$L;
        var n = this.clone(), a = H(r, i, !0);
        return a && (n.$L = a), n;
      }, s.clone = function() {
        return d.w(this.$d, this);
      }, s.toDate = function() {
        return new Date(this.valueOf());
      }, s.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, s.toISOString = function() {
        return this.$d.toISOString();
      }, s.toString = function() {
        return this.$d.toUTCString();
      }, o;
    }(), I = O.prototype;
    return p.prototype = I, [["$ms", T], ["$s", Y], ["$m", _], ["$H", Z], ["$W", M], ["$M", v], ["$y", U], ["$D", B]].forEach(function(o) {
      I[o[1]] = function(s) {
        return this.$g(s, o[0], o[1]);
      };
    }), p.extend = function(o, s) {
      return o.$i || (o(s, O, p), o.$i = !0), p;
    }, p.locale = H, p.isDayjs = P, p.unix = function(o) {
      return p(1e3 * o);
    }, p.en = L[j], p.Ls = L, p.p = {}, p;
  });
})(nt);
var It = nt.exports;
const R = /* @__PURE__ */ rt(It);
var st = { exports: {} };
(function(t, e) {
  (function(u, h) {
    t.exports = h();
  })(et, function() {
    var u = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, h = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, $ = /\d\d/, T = /\d\d?/, Y = /\d*[^-_:/,()\s\d]+/, _ = {}, Z = function(f) {
      return (f = +f) + (f > 68 ? 1900 : 2e3);
    }, M = function(f) {
      return function(m) {
        this[f] = +m;
      };
    }, X = [/[+-]\d\d:?(\d\d)?|Z/, function(f) {
      (this.zone || (this.zone = {})).offset = function(m) {
        if (!m || m === "Z")
          return 0;
        var D = m.match(/([+-]|\d\d)/g), y = 60 * D[1] + (+D[2] || 0);
        return y === 0 ? 0 : D[0] === "+" ? -y : y;
      }(f);
    }], v = function(f) {
      var m = _[f];
      return m && (m.indexOf ? m : m.s.concat(m.f));
    }, G = function(f, m) {
      var D, y = _.meridiem;
      if (y) {
        for (var x = 1; x <= 24; x += 1)
          if (f.indexOf(y(x, 0, m)) > -1) {
            D = x > 12;
            break;
          }
      } else
        D = f === (m ? "pm" : "PM");
      return D;
    }, U = { A: [Y, function(f) {
      this.afternoon = G(f, !1);
    }], a: [Y, function(f) {
      this.afternoon = G(f, !0);
    }], S: [/\d/, function(f) {
      this.milliseconds = 100 * +f;
    }], SS: [$, function(f) {
      this.milliseconds = 10 * +f;
    }], SSS: [/\d{3}/, function(f) {
      this.milliseconds = +f;
    }], s: [T, M("seconds")], ss: [T, M("seconds")], m: [T, M("minutes")], mm: [T, M("minutes")], H: [T, M("hours")], h: [T, M("hours")], HH: [T, M("hours")], hh: [T, M("hours")], D: [T, M("day")], DD: [$, M("day")], Do: [Y, function(f) {
      var m = _.ordinal, D = f.match(/\d+/);
      if (this.day = D[0], m)
        for (var y = 1; y <= 31; y += 1)
          m(y).replace(/\[|\]/g, "") === f && (this.day = y);
    }], M: [T, M("month")], MM: [$, M("month")], MMM: [Y, function(f) {
      var m = v("months"), D = (v("monthsShort") || m.map(function(y) {
        return y.slice(0, 3);
      })).indexOf(f) + 1;
      if (D < 1)
        throw new Error();
      this.month = D % 12 || D;
    }], MMMM: [Y, function(f) {
      var m = v("months").indexOf(f) + 1;
      if (m < 1)
        throw new Error();
      this.month = m % 12 || m;
    }], Y: [/[+-]?\d+/, M("year")], YY: [$, function(f) {
      this.year = Z(f);
    }], YYYY: [/\d{4}/, M("year")], Z: X, ZZ: X };
    function B(f) {
      var m, D;
      m = f, D = _ && _.formats;
      for (var y = (f = m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(H, p, d) {
        var O = d && d.toUpperCase();
        return p || D[d] || u[d] || D[O].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(I, o, s) {
          return o || s.slice(1);
        });
      })).match(h), x = y.length, N = 0; N < x; N += 1) {
        var j = y[N], L = U[j], C = L && L[0], P = L && L[1];
        y[N] = P ? { regex: C, parser: P } : j.replace(/^\[|\]$/g, "");
      }
      return function(H) {
        for (var p = {}, d = 0, O = 0; d < x; d += 1) {
          var I = y[d];
          if (typeof I == "string")
            O += I.length;
          else {
            var o = I.regex, s = I.parser, r = H.slice(O), i = o.exec(r)[0];
            s.call(p, i), H = H.replace(i, "");
          }
        }
        return function(n) {
          var a = n.afternoon;
          if (a !== void 0) {
            var c = n.hours;
            a ? c < 12 && (n.hours += 12) : c === 12 && (n.hours = 0), delete n.afternoon;
          }
        }(p), p;
      };
    }
    return function(f, m, D) {
      D.p.customParseFormat = !0, f && f.parseTwoDigitYear && (Z = f.parseTwoDigitYear);
      var y = m.prototype, x = y.parse;
      y.parse = function(N) {
        var j = N.date, L = N.utc, C = N.args;
        this.$u = L;
        var P = C[1];
        if (typeof P == "string") {
          var H = C[2] === !0, p = C[3] === !0, d = H || p, O = C[2];
          p && (O = C[2]), _ = this.$locale(), !H && O && (_ = D.Ls[O]), this.$d = function(r, i, n) {
            try {
              if (["x", "X"].indexOf(i) > -1)
                return new Date((i === "X" ? 1e3 : 1) * r);
              var a = B(i)(r), c = a.year, l = a.month, g = a.day, E = a.hours, S = a.minutes, A = a.seconds, V = a.milliseconds, F = a.zone, z = /* @__PURE__ */ new Date(), k = g || (c || l ? 1 : z.getDate()), w = c || z.getFullYear(), b = 0;
              c && !l || (b = l > 0 ? l - 1 : z.getMonth());
              var W = E || 0, J = S || 0, Q = A || 0, tt = V || 0;
              return F ? new Date(Date.UTC(w, b, k, W, J, Q, tt + 60 * F.offset * 1e3)) : n ? new Date(Date.UTC(w, b, k, W, J, Q, tt)) : new Date(w, b, k, W, J, Q, tt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(j, P, L), this.init(), O && O !== !0 && (this.$L = this.locale(O).$L), d && j != this.format(P) && (this.$d = /* @__PURE__ */ new Date("")), _ = {};
        } else if (P instanceof Array)
          for (var I = P.length, o = 1; o <= I; o += 1) {
            C[1] = P[o - 1];
            var s = D.apply(this, C);
            if (s.isValid()) {
              this.$d = s.$d, this.$L = s.$L, this.init();
              break;
            }
            o === I && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          x.call(this, N);
      };
    };
  });
})(st);
var kt = st.exports;
const Rt = /* @__PURE__ */ rt(kt);
R.extend(Rt);
const Ut = /undefined/i, Ft = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/, Zt = (t) => !t || t === "" || t.trim().length === 0, zt = (t) => t === !0 || t === void 0, Wt = (t) => t === void 0 || typeof t == "string" && Ut.test(t), Bt = (t) => t === null, K = (t) => Object.prototype.toString.call(t) === "[object Object]", Vt = (t, e, u) => R(t, e, u, !0).isValid(), Jt = (t) => !(!t || t.split("@").length != 2 || !Ft.test(t)), Xt = (t) => {
  if (Array.isArray(t)) {
    if (t.length === 0)
      return !0;
    const e = t[0];
    if (K(e) && "sections" in e)
      return !0;
  }
  return !1;
}, qt = (t) => !!(t && K(t) && typeof t == "object" && "label" in t && "value" in t), Gt = (t) => !!(t && K(t) && typeof t == "object" && "url" in t), Kt = (t, e) => t < e, Qt = (t, e) => t <= e, te = (t, e) => t > e, ee = (t, e) => t >= e, q = {
  isDataSource: Gt,
  isDate: Vt,
  isEmail: Jt,
  isEmpty: Zt,
  isGreaterThan: te,
  isGreaterThanOrEqualTo: ee,
  isLessThan: Kt,
  isLessThanThanOrEqualTo: Qt,
  isNull: Bt,
  isObject: K,
  isSelect: qt,
  isTab: Xt,
  isUndefined: Wt,
  isVisible: zt
}, re = (t, e = ",") => {
  const u = new RegExp("[^0-9-" + e + "]", "g"), h = `${t}`.replace(u, "").replace(e, "."), $ = parseFloat(h);
  return isNaN($) ? 0 : $;
}, ne = (t, e = {}) => {
  const {
    locale: u = "es-CO",
    currency: h = "COP",
    digits: $ = 2
  } = e;
  return (q.isNull(t) || q.isUndefined(t)) && (t = 0), new Intl.NumberFormat(u, {
    style: "currency",
    currency: h,
    minimumFractionDigits: $
  }).format(t);
}, se = {
  format: ne,
  unformat: re
};
function ie(t) {
  const e = R(t);
  return q.isDate(t) ? e.toDate() : null;
}
function oe(t, e = "DD/MM/YYYY") {
  let u = R();
  return t instanceof Date && (u = R(t)), u.format(e);
}
const ae = {
  format: oe,
  from: ie
};
function ce(t, e = ["YYYY-MM-DD", "HH:mm:ss"]) {
  let u = R();
  return t instanceof Date && (u = R(t)), u.format(e.join(" "));
}
const ue = {
  format: ce
}, fe = (t, e = 2) => t.toFixed(e), de = {
  format: fe
}, he = (t, e) => e === void 0 || t < e ? t : e, le = (t, e) => e === void 0 || t > e ? t : e, me = (t, e) => e === void 0 ? t : t > e ? e : t, $e = (t, e) => e === void 0 ? t : t < e ? e : t, Pe = {
  minOf: he,
  maxOf: le,
  minBy: $e,
  maxBy: me
}, pe = (t, e) => {
  if (!e || !t)
    return "";
  t = t.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const h = new RegExp("[\\?&]" + t + "=([^&#]*)").exec(e);
  return h === null ? "" : decodeURIComponent(h[1].replace(/\+/g, " "));
}, be = {
  query: pe
}, Me = "label", De = "value", ye = (t, e) => {
  const u = (e == null ? void 0 : e.label.split(".").filter(($) => $ !== "")) ?? [
    Me
  ], h = (e == null ? void 0 : e.value.split(".").filter(($) => $ !== "")) ?? [
    De
  ];
  return it(t, u, h);
}, it = (t, e, u) => t.map((h) => {
  const $ = e == null ? void 0 : e.reduce((Y, _) => Y && Y[_], h), T = u == null ? void 0 : u.reduce((Y, _) => Y && Y[_], h);
  return {
    label: $,
    value: T
  };
}), ge = {
  convert: it,
  prepare: ye
}, Ye = (t, e) => (t.order || 0) - (e.order || 0), Ce = {
  asc: Ye
}, Te = (t, e) => {
  if (!ot(t, e) || !e.parameter)
    return e;
  const u = {
    ...t
  };
  u.parameter = u.parameter || {};
  for (const [h, $] of Object.entries(e.parameter))
    if (!(h in u.parameter))
      u.parameter = {
        ...u.parameter,
        [h]: $
      };
    else if (u.parameter) {
      const T = u.parameter[h];
      if (T && typeof T == "string") {
        const Y = T.split(",");
        Y.push(`${$}`), u.parameter[h] = Y.join(",");
      }
    }
  return u;
}, ot = (t, e) => !t || !e || t.url !== e.url || t.method !== e.method || t.namespace !== e.namespace || JSON.stringify(t.parameter) !== JSON.stringify(e.parameter), Ee = (t, e) => {
  var u, h;
  return q.isObject(t) && ((h = (u = e == null ? void 0 : e.split(".")) == null ? void 0 : u.filter(($) => $ !== "")) == null || h.forEach(($) => {
    t && (t = t[$]);
  })), t;
}, He = {
  diff: ot,
  extract: Ee,
  merge: Te
}, _e = /^(\d{0,2}):?(\d{0,2}):?(\d{0,2})\s?([AaPp][Mm])?$/, Se = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/, we = (t) => {
  t = t == null ? void 0 : t.replace(Se, "").trim();
  const e = t == null ? void 0 : t.match(_e);
  return [
    e && e[1] ? e[1] : void 0,
    e && e[2] ? e[2] : void 0,
    e && e[3] ? e[3] : void 0,
    e && e[4] ? e[4] : void 0
  ];
};
function at(t) {
  const e = we(t);
  if (q.isUndefined(e[0]))
    return null;
  let u = e[0] ? Number(e[0]) : 0;
  e[3] && e[3].toLowerCase() === "pm" && (u = 12 + u);
  const h = e[1] ? Number(e[1]) : 0, $ = e[2] ? Number(e[2]) : 0;
  return R().hour(u).minute(h).second($).toDate();
}
function Oe(t, e = "HH:mm") {
  let u = R();
  if (t instanceof Date && (u = R(t)), typeof t == "string" && t !== "now") {
    const h = at(t);
    if (q.isNull(h))
      return null;
    u = R(h);
  }
  return u.format(e);
}
const ve = {
  format: Oe,
  from: at
}, Ne = {
  currency: se,
  date: ae,
  datetime: ue,
  decimal: de,
  time: ve
}, je = {
  select: ge
};
export {
  xe as accent,
  jt as color,
  Ae as constants,
  Ne as formatter,
  je as helper,
  Pe as math,
  be as router,
  Ce as sort,
  He as source,
  q as validator
};
